// Stage display order — the settings page's fixed type sections decide stage
// order everywhere: pending → inProgress → done → canceled (the declaration
// order of STAGE_TYPES), then sortOrder within a type. sortOrder is NOT
// globally normalized across types (settings drag-reorder is confined to a
// type section and computes midpoints against section siblings only), so
// ordering by raw sortOrder puts terminal stages wherever their sortOrder
// happens to fall. Every view-facing stage list must sort with compareStages.

import { STAGE_TYPES } from "#app/lib/data";

type StageOrderKey = {
  type?: string | null;
  sortOrder?: number | null;
};

function typeRank(type: string | null | undefined): number {
  const index = STAGE_TYPES.indexOf(type as (typeof STAGE_TYPES)[number]);
  return index === -1 ? STAGE_TYPES.length : index;
}

export function compareStages(a: StageOrderKey, b: StageOrderKey): number {
  return (
    typeRank(a.type) - typeRank(b.type) ||
    (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
  );
}
